  const generateSrcset = (image, widths = []) => {
    const imageUrl = new URL(image["src"]);
    return widths.filter((width) => width <= image["width"]).map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    }).join(", ");
  }

  const createImageElement = (image, classes, sizes, productTitle) => {
    const previewImage = image["preview_image"];
    const newImage = new Image(previewImage["width"], previewImage["height"]);
    newImage.className = classes;
    newImage.alt = image["alt"] || productTitle;
    newImage.sizes = sizes;
    newImage.src = previewImage["src"];
    newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
    newImage.loading="lazy"
    return newImage;
  }

  const checkSwatches = () => {
    document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
      wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
        input.addEventListener('click', (event) => {
          const primaryImage = wrapper.querySelector(".media--first");
          const secondaryImage = wrapper.querySelector(".media--second");
          const handleProduct = wrapper.dataset.product;
          
          if (event.currentTarget.checked && primaryImage) {
            wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
              wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
            }
            
            const currentColor = event.currentTarget.value;

            jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
              const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

              if (variant) {
                const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                
                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove('media--second');
                      secondaryImage.classList.add('media--first');
                      flag = true;
                    } 
                  }
                  if (flag == false) {
                    primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                    setTimeout(function(){
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                      if (secondaryImage) {
                        secondaryImage.remove();                                    
                      }
                    }, 200);
                  }
                }
              }
            });
          }
        })
      })
    })
  }

  function colorSwatches() {
    checkSwatches();

    document.addEventListener('shopify:section:load', function () {
      checkSwatches();
    });
  }

(function () {
  colorSwatches();
})();

/* Uzbraucot uz krāsas parauga, kartītē rāda tā varianta bildi; aizejot no paraugiem, atgriežas izvēlētā. */
(function () {
  const produkti = {};
  const produkts = (h) => (produkti[h] = produkti[h] || fetch(window.Shopify.routes.root + 'products/' + h + '.js').then((r) => r.json()));
  const atjaunot = (w) => {
    const img = w.querySelector('.media--first');
    if (img && img.dataset.swatchSrc !== undefined) {
      img.src = img.dataset.swatchSrc;
      img.srcset = img.dataset.swatchSrcset;
      delete img.dataset.swatchSrc;
      delete img.dataset.swatchSrcset;
    }
    if (img) img.style.removeProperty('opacity');
    const sec = w.querySelector('.media--second');
    if (sec) sec.style.removeProperty('opacity');
    delete w.dataset.swatchHover;
  };
  const radit = (w, input) => {
    const img = w.querySelector('.media--first');
    if (!img || !w.dataset.product) return;
    w.dataset.swatchHover = input.value;
    const kartesDati = () => {
      try {
        const s = w.querySelector('variant-radios script[type="application/json"]');
        const v = s && JSON.parse(s.textContent).find((x) => x.featured_media && x.featured_media.src && x.options.includes(input.value));
        if (!v) return null;
        const src = new URL(v.featured_media.src, location.href);
        return { src: src.href, width: v.featured_media.w || 1066 };
      } catch (e) {
        return null;
      }
    };
    const avots = kartesDati()
      ? Promise.resolve(kartesDati())
      : produkts(w.dataset.product).then((p) => {
          const v = p.variants.find((x) => x.featured_media && x.featured_media.preview_image && x.options.includes(input.value));
          return v ? v.featured_media.preview_image : null;
        });
    avots.then((pi) => {
      if (w.dataset.swatchHover !== input.value || !pi) return;
      if (img.dataset.swatchSrc === undefined) {
        img.dataset.swatchSrc = img.src;
        img.dataset.swatchSrcset = img.srcset || '';
      }
      img.loading = 'eager';
      img.srcset = generateSrcset(pi, [165, 360, 533, 720, 940, 1066]);
      img.src = pi.src;
      img.style.opacity = '1';
      const sec = w.querySelector('.media--second');
      if (sec) sec.style.opacity = '0';
    }).catch(() => {});
  };
  const apstiprinat = (w) => {
    const img = w.querySelector('.media--first');
    if (!img || img.dataset.swatchSrc === undefined) return;
    delete img.dataset.swatchSrc;
    delete img.dataset.swatchSrcset;
    img.style.removeProperty('opacity');
    const sec = w.querySelector('.media--second');
    if (sec) sec.remove();
  };
  const piesaistit = () => {
    document.querySelectorAll('.js-color-swatches-wrapper').forEach((w) => {
      if (w.dataset.swatchHoverReady) return;
      w.dataset.swatchHoverReady = '1';
      w.querySelectorAll('.js-color-swatches input').forEach((input) => {
        const label = w.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        if (label) label.addEventListener('mouseenter', () => radit(w, input));
        input.addEventListener('click', () => apstiprinat(w));
      });
      w.querySelectorAll('.js-color-swatches').forEach((f) => f.addEventListener('mouseleave', () => atjaunot(w)));
    });
  };
  piesaistit();
  document.addEventListener('shopify:section:load', piesaistit);
  let gaida = false;
  new MutationObserver(() => {
    if (gaida) return;
    gaida = true;
    requestAnimationFrame(() => { gaida = false; piesaistit(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
